const setValidity = {
  bindings: {
    workspace: '<',
    mode: '<',
    onSubmit: '&',
    onCancel: '&'
  },
  templateUrl:
    '/modules/pis-tool/workspaces/workspace-modal/set-validity/set-validity.html',
  controller: 'SetValidityController',
};

angular
  .module('pis-tool.module')
  .component('setValidity', setValidity);
